// extracted by mini-css-extract-plugin
export default {"container":"image-crop_container__bSF0-","wrapper":"image-crop_wrapper__yCVw0","controls":"image-crop_controls__v+XOP","img":"image-crop_img__4VPSJ"};